<template>
    <TestRecords/>
</template>
<script>
import TestRecords from 'place/answer/testRecords.vue'
export default {
    components:{
        TestRecords
    }
}
</script>